import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import BadgeDirective from 'primevue/badgedirective'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import Dialog from 'primevue/dialog'
import App from './App.vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import './assets/main.scss'
import 'primevue/resources/themes/lara-light-cyan/theme.css'

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://9bef626d16bc15445f17fad65a50c596@o4507544458493952.ingest.us.sentry.io/4507544461639680',
  environment: import.meta.env.VITE_APP_ENV,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // TODO: adjust with tracesSampler later
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^https:\/\/poshpoptools\.com/],
  ignoreErrors: [
    // Network/Connectivity related
    'NetworkError',
    'Network request failed',
    'Failed to fetch',
    'Load failed',
    'Request failed',
    'The network connection was lost',
    'A network error occurred',
    'net::ERR_INTERNET_DISCONNECTED',
    'net::ERR_NETWORK_CHANGED',
    'net::ERR_CONNECTION_RESET',
    'net::ERR_CONNECTION_REFUSED',
    'net::ERR_EMPTY_RESPONSE',
    'net::ERR_TIMED_OUT',
    'net::ERR_NAME_NOT_RESOLVED',
    'net::ERR_ABORTED',

    // CORS and browser-related
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
    'AbortError: The user aborted a request.',
    'TypeError: Cancelled',
    'TypeError: NetworkError when attempting to fetch resource.',

    // Ad blockers / extensions interference
    'Blocked a frame with origin',
    'Script error.',
    'SecurityError',
    'ResizeObserver loop limit exceeded'
  ]
})

app.use(pinia)
app.use(PrimeVue)
app.use(router)
app.use(ToastService)
app.use(ConfirmationService)
app.directive('badge', BadgeDirective)
app.directive('tooltip', Tooltip)
app.component('Dialog', Dialog)
app.mount('#poshpop-extension-app')
